






























import { Component, Prop, Vue } from "vue-property-decorator";
import IDocument from '@/models/document';
import ITodoCollection from '@/models/todoCollection';
import firebase from 'firebase';
import {TodoDataServicesCollection} from '@/accessors/TodoDataServicesCollection';
import router from '@/router/index';
import HomeViewModule from '@/store/view/HomeViewModule';
import {Loading} from 'quasar';
import DocumentModule from '@/store/application/DocumentModule';

@Component({
    filters: {
        truncateSubject(value: string) {
            if (value.length > 40) {
                return value.slice(0, 40) + '...';
            } else {
                return value;
            }
        }, 
        truncateBody(value: string) {
            if (value.length > 110) {
                return value.slice(0, 110) + '...';
            } else {
                return value;
            }
        }
    }
})
export default class ChecklistsList extends Vue {
    public adminId = process.env.VUE_APP_FIREBASE_ADMIN;

    public async openChecklist(document: ITodoCollection) {
        Loading.show()
        await DocumentModule.loadDocument(document.id);
        Loading.hide()
        router.push({name: 'todo', params: {id: document.id}});
        this.$gtag.event('todoClicked', {event_category: `${document.subject} was clicked.`, event_label: `${document.topic}`, value: 0} );
    }

    public async openNotecard(document: ITodoCollection) {
        Loading.show()
        await DocumentModule.loadDocument(document.id);
        Loading.hide()
        router.push({name: 'notecards', params: {id: document.id}})
        this.$gtag.event('notecardClicked', {event_category: `${document.subject} was clicked.`, event_label: `${document.topic}`, value: 0} );
    }

    public async openQuiz(document: ITodoCollection) {
        Loading.show()
        await DocumentModule.loadDocument(document.id);
        Loading.hide()
        router.push({name: 'quiz', params: {id: document.id}})
        this.$gtag.event('quizClicked', {event_category: `${document.subject} was clicked.`, event_label: `${document.topic}`, value: 0} );
    }

    public get documents() {
        if (HomeViewModule.filteredDocuments.length) {
            return (HomeViewModule.filteredDocuments.filter((document) => (document.userId === (this.user.data ? this.user.data.uid : ''))  || document.userId === undefined));
        }
        return HomeViewModule.documents.filter((document) => (document.userId === (this.user.data ? this.user.data.uid : ''))  || document.userId === undefined);
    }

    public get user() {
        return this.$store.getters.user;
    }

    beforeMount() {
        firebase.auth().onAuthStateChanged(async () => {
            await HomeViewModule.loadDocuments(this.$store.getters.user);
        })
    }
}
